import { balancaConfig } from "./balanca";
import { inmetroNaPalmaDaMaoConfig } from "./inmetro-na-palma-da-mao";
import { ngConfig } from "./ng";
import type { ProductConfig } from "./type";
import { validaInstrumentoConfig } from "./valida-instrumento";
import { validadorPrimiConfig } from "./validador-primi";
import { worldComexxConfig } from "./world-comexx";

const configs = [
	worldComexxConfig,
	ngConfig,
	validadorPrimiConfig,
	validaInstrumentoConfig,
	balancaConfig,
	inmetroNaPalmaDaMaoConfig,
];

const domainConfigMap: Record<string, ProductConfig> = configs.reduce(
	(map, config) => {
		config.product.domains.forEach((domain) => {
			map[domain] = config;
		});
		return map;
	},
	{} as Record<string, ProductConfig>,
);
// Config de desenvolvimento
domainConfigMap["localhost"] = validadorPrimiConfig;
domainConfigMap["127.0.0.1"] = validadorPrimiConfig;

export function getCurrentProduct(): ProductConfig {
	const hostname = window.location.hostname;
	const config = domainConfigMap[hostname];

	if (!config) {
		console.warn(
			`Configuração não encontrada para domínio: ${hostname}. Usando configuração padrão.`,
		);
		return ngConfig;
	}

	return config;
}

export function useCurrentProduct() {
	return getCurrentProduct();
}

export type { ProductConfig };
export {
	worldComexxConfig,
	ngConfig,
	validadorPrimiConfig,
	validaInstrumentoConfig,
	inmetroNaPalmaDaMaoConfig,
};
